import ComingSoon from './ComingSoon';

export default function Proposals() {
  return <ComingSoon title="Təkliflər" />;
}
